export default {
    orderItemList: [
        {
            label: '接单量',
            prop: 'pick_order_num',
            iconUrl: require('../images/order_quantity.png'),
            bgc: 'order_quantity_bgc'
        },
        {
            label: '在途量',
            prop: 'on_order_inventory',
            iconUrl: require('../images/transit.png'),
            bgc: 'transit_bgc'
        },
        {
            label: '网点签收',
            prop: 'sign_order_num',
            iconUrl: require('../images/sign.png'),
            bgc: 'sign_bgc'
        },
        {
            label: '预约量',
            prop: 'booking_order_num',
            iconUrl: require('../images/booked.png'),
            bgc: 'booked_bgc'
        },
        {
            label: '派工量',
            prop: 'dispatching_order_num',
            iconUrl: require('../images/dispatch.png'),
            bgc: 'dispatch_bgc'
        },
        {
            label: '入库量',
            prop: 'receipt_order_num',
            iconUrl: require('../images/warehousing.png'),
            bgc: 'warehousing_bgc'
        },
        {
            label: '审核量',
            prop: 'review_order_num',
            iconUrl: require('../images/warehouse_out.png'),
            bgc: 'warehouse_out_bgc'
        },
        {
            label: '完成量',
            prop: 'complete_order_num',
            iconUrl: require('../images/complete.png'),
            bgc: 'complete_bgc'
        }
    ]
};